<template>
    <button type="submit" class="btn btn-success" :class="{'btn-danger': status === false}" :disabled="loading"
            @click="click">
        <slot>Zapisz</slot>
        <span v-show="loading"><i class="fa fa-cog fa-spin fa-fw"></i></span>
        <span v-show="!loading && status.length > 0 && status"><i class="fa fa-check"></i></span>
        <span v-show="!loading && status.length > 0 && !status"><i class="fa fa-exclamation-triangle"></i></span>
    </button>
</template>
<script>
  export default {
    props: {
      loading: {
        type: Boolean,
        default: false,
      },
      status: {
        type: String | Boolean,
        default: '',
      },
    },
    methods: {
      click() {
        this.status = '';
        this.$emit('click');
      },
    },
  };
</script>
